export const SET_ZOO_FILTER = 'SET_ZOO_FILTER';
export const TOGGLE_ZOO_FILTER = 'TOGGLE_ZOO_FILTER';

export const SET_ANIMAL_FILTER = 'SET_ANIMAL_FILTER';
export const TOGGLE_ANIMAL_FILTER = 'TOGGLE_ANIMAL_FILTER';

export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const SET_QUERY_URL = 'SET_QUERY_URL';

export const SET_ALBUM_DATA = 'myAlbum/SET_ALBUM_DATA';
export const UPDATE_ALBUM_DATA = 'myAlbum/UPDATE_ALBUM_DATA';
export const APPEND_ALBUM_DATA = 'myAlbum/APPEND_ALBUM_DATA';
export const CHANGE_CONTENT_VISIBILITY = 'myAlbum/CHANGE_CONTENT_VISIBILITY';
export const REMOVE_MEDIA_FROM_ALBUM = 'myAlbum/REMOVE_MEDIA_FROM_ALBUM';
export const SET_TYPE = 'SET_TYPE';
export const SET_PAGE = 'SET_PAGE';
export const SET_CLOSE_SHARE_MODAL = 'SET_CLOSE_SHARE_MODAL';
export const SET_SHARE_MODAL_MEDIA_ID = 'SET_SHARE_MODAL_MEDIA_ID';
export const SET_HABITAT = 'SET_HABITAT';
export const SET_SHARE_MODAL_DATA = 'SET_SHARE_MODAL_DATA';
export const CLOSE_SHARE_MODAL = 'CLOSE_SHARE_MODAL';

export const PHOTOS = 'photos';
export const PAST_TALKS = 'pastTalks';
export const CLIPS = 'clips';
export const STREAMS = 'streams';
